// 计算元素在页面的位置
export const computeEleLocation = function ($el) {
  let scrollHeight = window.pageYOffset || document.documentElement.scrollTop;
  let top = $el.getBoundingClientRect().top;
  return scrollHeight + top;
}

// 计算元素的中间位置是否出现在屏幕中间（元素中间位置高于屏幕中间位置）
export const computeEleShow = function ($el) {
  let scrollHeight = window.pageYOffset || document.documentElement.scrollTop;
  let innerHeight = window.innerHeight;
  let { top, height } = $el.getBoundingClientRect();
  let a = scrollHeight + top + (height / 2 - 1);
  let b = scrollHeight + top + (height - height / 2 + 1);
  let bool = scrollHeight + innerHeight > a && scrollHeight < b;
  return bool;
}

// 判断设备类型
export const deviceType = function () {
  const userAgent = window.navigator.userAgent;
  const ua = userAgent.toLowerCase();
  const platform = {
    isAndroid: function () {
      return ua.indexOf('android') > -1;
    },
    isIOS: function () {
      return ua.indexOf('iphone') > -1;
    },
    isWinPhone: function () {
      return !!navigator.userAgent.match(/Windows Phone/i);
    },
    isIpad: function () {
      var NPlatform = navigator.platform;
      return (
        /iPad/gi.test(NPlatform) ||
        (NPlatform === 'MacIntel' &&
          navigator.maxTouchPoints > 1 &&
          !window.MSStream)
      );
    },
    isPhone: function () {
      return (
        this.isAndroid() || this.isIOS() || this.isWinPhone() || this.isIpad()
      );
    },
    isIE11: function () {
      return (
        userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
      );
    },
    isEdge: function () {
      return userAgent.indexOf('Edge') > -1;
    },
  };
  if (!platform.isPhone() || platform.isIE11() || platform.isEdge()) {
    return 'pc';
  }
  if (platform.isIOS() || platform.isIpad()) {
    return 'ios';
  }
  if (platform.isAndroid()) {
    return 'android';
  }
  return '其他';
}

// 创建节流函数
export const throttle = function (cb, time = 300) {
  let timer = null;
  let bool = false;
  return () => {
    if (bool) {
      return;
    }
    bool = true;
    clearTimeout(timer);
    timer = setTimeout(() => {
      cb();
      bool = false;
    }, time)
  }
}

// 创建防抖函数
export const antiShake = function (cb, time = 300) {
  let timer = null;
  return () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      cb();
    }, time)
  }
}

/**
 * 获取当前页面链接的参数
 * @param {string} name - the param need to find.
 * @return {string} The result of the find.
 */
export function getParam(name, href) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  let realparams = decodeURIComponent(window.location.search.substr(1));
  if (href && href.indexOf("?") > -1) {
    realparams = href.split("?")[1];
  }
  let r = realparams.match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return '';
}
